
export const EduquestCertificateidUpload = (data) => {
    var formdata = new FormData()
    console.log(data);

    if(data.attachments){
        formdata.append('attachments',data.attachments.rawFile)
    }
     if(data.orderID_type){
        formdata.append('orderID_type',data.orderID_type)
    }

    return formdata;
}